function prepareFadeIn(element) {
  element.style.opacity = 0;
  
  return {
    run() {
      return new Promise((resolve) => {
        element.animate(
          [
            // keyframes
            { opacity: 0 },
            { opacity: 1 },
          ],
          {
            // timing options
            duration: 200,
            iterations: 1,
          },
        ).addEventListener('finish', () => {
          element.style.opacity = '';

          resolve();
        });
      })
    }
  }
}

export default prepareFadeIn;
